export const RadiansToDegrees = (radians: number) => {
  return radians * (180 / Math.PI);
};

export const convertTo2DArray = (nums: number[], unit: number) => {
  const result: number[][] = [];
  for (let i = 0; i < nums.length; i += unit) {
    result.push(nums.slice(i, i + unit));
  }
  return result;
};
